// BroadcastChannel works asynchronously, and we need to lock the other tabs while waiting for the token refresh to complete

class LocalStorageLocker {
  private LOCK_KEY = 'refresh_token_lock'
  private LOCK_TTL = 10000 // 10 seconds

  public setLock(): void {
    localStorage.setItem(this.LOCK_KEY, Date.now().toString())
  }

  public clearLock(): void {
    localStorage.removeItem(this.LOCK_KEY)
  }

  public isLocked(): boolean {
    const lockTime = parseInt(localStorage.getItem(this.LOCK_KEY) || '0', 10)
    const now = Date.now()
    return now - lockTime < this.LOCK_TTL
  }
}

export const localStorageLocker = new LocalStorageLocker()
